import { Box } from '@mui/material';
import Form from '@rjsf/mui';
import { useEffect, useRef } from 'react';
import StepContainer from './step-container.component';

export default function StepComponent(props) {
  const { stepId, partialKey, onChange, onClear, stepProps } = props;

  const formRef = useRef(null);
  const { header, footer } = stepProps.helperText || {};

  const content = (
    <>
      {header ? <Box>{header}</Box> : ''}

      <Form
        ref={formRef}
        onChange={() => onChange(stepId, formRef)(partialKey)}
        onClear={onClear(stepId)}
        {...stepProps}
      >
        <div></div>
      </Form>

      {footer ? <Box>{footer}</Box> : ''}
    </>
  );

  // Perform initial validation, as some of the form fields may have inter-dependencies with other steps.
  useEffect(() => {
    if (formRef.current) {
      formRef.current.validateForm();
    }
  }, []);

  return stepProps.skipContainer ? content : <StepContainer>{content}</StepContainer>;
}
